import _get from "lodash/get";
export var getIsRequestPendingForGetFeed = function getIsRequestPendingForGetFeed(identity) {
  return _get(identity, 'requests.getFeed.hasPendingRequests');
};
export var getFeedItems = function getFeedItems(identity) {
  return _get(identity, 'feed.feedItems');
};
export var getStatementIndexedFeedItems = function getStatementIndexedFeedItems(identity) {
  return _get(identity, 'feed.statementIndexedFeedItems');
};